import { Stack } from '@mui/material';

import { EditableRegion } from '@/components/blockEditor/EditableRegion/EditableRegion';

import { VERTICAL_SPACING } from '../../components/EducationalSlide.components';

export function Draft() {
  return (
    <Stack spacing={VERTICAL_SPACING}>
      <EditableRegion regionId="root" />
    </Stack>
  );
}
